<template>
  <div class="lcu-unauth-nav" :class="{
      'lcu-unauth-navISO': _device.iPhone && _device.app,
    }">
    <div class="lcu-nav-wrap">
      <div class="lcu-unauth-inner">
        <div class="lcu-unauth-left">
          <a class="lcu-unauthEmail-link" href="mailto:info@universidadlegacy.com">
            info@universidadlegacy.com
          </a>
        </div>
        <div class="lcu-unauth-right">
          <router-link
            v-if="!user.id"
            class="lcu-unauth-link lcu-icon-login"
            :class="{
              'lcu-unauth-linkActive': $router.currentRoute.value.path.match(/^\/iniciar-sesion/gi),
            }"
            to="/iniciar-sesion">
            Iniciar Sesión
          </router-link>
          <span v-if="user.id" class="lcu-unauth-link lcu-icon-login">
            Hola {{ user.firstName }}!
          </span>
          <a
            v-if="!user.id"
            href="#"
            class="lcu-unauth-link lcu-unauth-linkCTA"
            @click.prevent="checkLink('/inscribirse')">
            Aplicar
          </a>
          <a
            v-if="user.id"
            href="#"
            class="lcu-unauth-link lcu-unauth-linkCTA"
            @click.prevent="checkLink('/panel-de-control')">
            Portal estudiantil
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'unauth-nav',
  components: {
  },
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  data() {
    return {
      loginModal: false,
    };
  },
  methods: {
    checkLink(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-unauth-nav {
  align-items: center;
  background-color: $legacy-primary;
  border-bottom: 1px solid rgba($white, .2);
  color: $light-gray-text;
  display: flex;
  height: $public-nav-height;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition-duration: .2s;
  width: 100%;
  z-index: 5;

  @media only screen and (max-width: $mobile-max) {
    border-right: none;
    border-top: 1px solid rgba($white, .2);
    bottom: 0;
    height: 70px;
    padding: 0;
    right: 0;
    top: auto;
    width: 100%;
    z-index: 10;
  }

  @media print {
    display: none;
  }
}

.lcu-nav-wrap {
  max-width: 1280px;
  position: relative;
  width: 90%;
  height: 100%;

  @media only screen and (max-width: $mobile-max) {
    width: 80%;
  }
}

.lcu-unauth-inner {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  padding: 0;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-unauth-navISO {

  .lcu-nav-wrap {
    top: -5px;

    @include ipad-pro-12 {
      top: 0;
    }
  }

  @media only screen and (max-width: $mobile-max) {
    height: 80px;
  }

  @include ipad-pro-12 {
    top: 25px;
  }
}

.lcu-unauth-left {
  align-items: center;
  display: flex;
  justify-content: flex-start;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

.lcu-unauth-right {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  @media only screen and (max-width: $mobile-max) {
    justify-content: space-between;
  }
}

.lcu-unauth-navLogo {
  margin-right: 35px;
  width: 120px;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

.lcu-unauth-links {
  padding-top: 50px;

  @media only screen and (max-width: $mobile-max) {
    align-items: center;
    border-top: 1px solid rgba($white, .2);
    display: flex;
    justify-content: space-between;
    padding: 9px 20px 3px;
  }
}

.lcu-unauth-linksISO {

  @media only screen and (max-width: $mobile-max) {
    padding: 10px 20px 5px;
  }
}

.lcu-unauthEmail-link {
  color: $light-gray-text;
  display: inline-flex;
  margin-right: 25px;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  transition-duration: .2s;
  white-space: nowrap;
  height: 100%;
  align-items: center;

  &:hover {
    color: $white;

    &:before {
      color: $white;
    }
  }
}

.lcu-unauth-link {
  color: $light-gray-text;
  display: inline-flex;
  margin-right: 25px;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  transition-duration: .2s;
  white-space: nowrap;
  height: 100%;
  align-items: center;
  padding: 5px 15px;

  &:hover {
    color: $white;

    &:before {
      color: $white;
    }
  }

  &:before {
    display: inline-block;
    font-family: 'lcu';
    margin-right: 5px;
    transition-duration: .2s;
  }

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }

  @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
    margin-right: 15px;
    font-size: 14px;
  }

  @media only screen and (max-width: $mobile-max) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    margin-bottom: 0;
    margin-right: 0;
    padding: 3px;
    text-decoration: center;

    &:before {
      display: block;
      font-size: 16px;
      margin-bottom: 5px;
      margin-right: 0;
      margin-left: 0;
      width: initial;
    }
  }
}

.lcu-unauth-linkCTA {
  background: $legacy-secondary;
  color: $white;

  @media only screen and (max-width: $mobile-max) {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.lcu-unauth-active {
  color: $white;
  font-weight: bold;

  &:before {
    color: $legacy-secondary;
  }
}

.lcu-unauth-linkActive {
  color: $white;

  &:before {
    color: $legacy-secondary;
  }
}

.lcu-icon-login {

  &:before {
    content: '\e80d';
  }
}

.lcu-icon-enroll {

  &:before {
    content: '\e80d';
  }
}
</style>
